import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { LOCATION_SEARCHABLE_READ } from "../const/LocationConst";

/**
 * Data Access for the Location API
 * @name LocationDao
 * @param {*} props
 * @returns {Promise<any>}
 */
const LocationDao = async (props) => {
    const { action, params, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "locationsSearchableRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = LOCATION_SEARCHABLE_READ;
            break;
        default:
            return null;
    }

    const response = await ServiceWrapper.serviceCall({
        options,
        ...props
    });

    return response;
};

LocationDao.propTypes = {
    action: PropTypes.string.isRequired,
    params: PropTypes.oneOfType([PropTypes.object]),
    token: PropTypes.string.isRequired
};

LocationDao.defaultProps = {
    params: null
};

export default LocationDao;
